import React from "react";

import { Card, CardBody } from "@patternfly/react-core";

import "./MegaMenuPanel.css";

const MegaMenuPanel = ({ body, footer }) => {
  return (
    <Card isGlass className="school-mega-menu-panel">
      <CardBody className="school-mega-menu-panel__body">
        {body}
      </CardBody>

      {footer && (
        <div className="school-mega-menu-panel__footer">
          {footer}
        </div>
      )}
    </Card>
  );
};

export default MegaMenuPanel;